export default "__VITE_ASSET__BUGdeoko__"